import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ArrowLeftOnRectangleIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/24/outline';
import { NAV_GROUPS } from './adminNavConfig';
import { useAuth } from '../../components/AuthContext';

// Sidebar fijo de PC — colapsable a solo-íconos (el ancho se recuerda en
// localStorage vía el estado que le pasa AdminRoutes). Móvil no lo ve nunca
// (md:flex): ahí manda la barra inferior + el sheet "Más".
//
// Nota: el chat con clientes (AdminMessagingLauncher) no vive aquí — tiene su
// propia burbuja flotante fija en pantalla, siempre visible sin importar la
// ruta, así que no necesita un enlace de menú aparte.
const AdminSidebar = ({ collapsed, onToggleCollapse }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <aside
      className={`fixed inset-y-0 left-0 z-40 hidden flex-col border-r border-gray-200 bg-white transition-all duration-200 md:flex ${
        collapsed ? 'w-[76px]' : 'w-64'
      }`}
    >
      <div className="flex h-16 flex-shrink-0 items-center gap-2 border-b border-gray-100 px-4">
        <img src="/logo-bbts.png" alt="BBTS" className="h-8 w-auto flex-shrink-0" />
        {!collapsed && <span className="truncate text-base font-semibold text-gray-800">Panel Admin</span>}
      </div>

      <nav className="flex-1 overflow-y-auto px-3 py-4">
        {NAV_GROUPS.map((group) => (
          <div key={group.label} className="mb-5">
            {!collapsed && (
              <p className="mb-1.5 px-2.5 text-[11px] font-bold uppercase tracking-wide text-gray-400">
                {group.label}
              </p>
            )}
            <ul className="space-y-0.5">
              {group.items.map(({ name, icon: Icon, to }) => (
                <li key={name}>
                  <NavLink
                    to={to}
                    // Email Studio vive exactamente en /admin/marketing. Sin
                    // `end`, React Router también lo marca activo en cada
                    // subruta (Campañas, Meta, Landing Studio, etc.).
                    end={to === '/admin/marketing'}
                    title={collapsed ? name : undefined}
                    className={({ isActive }) =>
                      `flex items-center gap-3 rounded-lg px-2.5 py-2 text-sm font-medium transition ${
                        collapsed ? 'justify-center' : ''
                      } ${
                        isActive
                          ? 'bg-orange-50 text-orange-700'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`
                    }
                  >
                    <Icon className="h-5 w-5 flex-shrink-0" />
                    {!collapsed && <span className="truncate">{name}</span>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      <div className="flex-shrink-0 border-t border-gray-100">
        <button
          type="button"
          onClick={handleLogout}
          title={collapsed ? 'Cerrar sesión' : undefined}
          className={`flex w-full items-center gap-2 px-4 py-3 text-sm font-medium text-red-600 transition hover:bg-red-50 ${collapsed ? 'justify-center' : ''}`}
        >
          <ArrowLeftOnRectangleIcon className="h-5 w-5 flex-shrink-0" />
          {!collapsed && <span>Cerrar sesión</span>}
        </button>
        <button
          type="button"
          onClick={onToggleCollapse}
          className="flex w-full items-center justify-center gap-2 border-t border-gray-100 py-3 text-xs font-medium text-gray-400 transition hover:bg-gray-50 hover:text-gray-600"
        >
          {collapsed ? (
            <ChevronDoubleRightIcon className="h-4 w-4" />
          ) : (
            <>
              <ChevronDoubleLeftIcon className="h-4 w-4" />
              Colapsar
            </>
          )}
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
